<form [formGroup]="form" (ngSubmit)="onSubmit()" class="no-live-loading">
	<mat-form-field class="{{ matFieldClass }}">
		<mat-label [innerHTML]="searchLabel"></mat-label>
		<i matPrefix role="icon" class="bx {{icon}}" [ngClass]="{ 'text-secondary': disabled }"></i>
		
		<input #searchInput matInput type="text" formControlName="search" (click)="searchInput.select()"  [matAutocomplete]="topbarSearch" [required]="inputRequired" />
		
		<i *ngIf="records !== null" matSuffix class="text-danger cursor-pointer bx font-size-16 bxs-x-circle" (click)="resetSearch()" [ngClass]="{ 'text-secondary': disabled }"></i>

		<mat-autocomplete #topbarSearch="matAutocomplete" [panelWidth]="panelWidth" style="overflow:unset" (closed)="action.stop()"
			class="search rounded-dropdown autocomplete-{{ fieldSize }} {{ form.loading }}"
			(optionSelected)="onSelect($event.option.value)">

			<div *ngIf="searchScope.length >=2 && (userScope.length > 0 || totalRecords > pageSize)" class="text-center">
				<button class="btn btn-sm btn-{{ userScope.indexOf('k') < 0 ? '' : 'outline-light'}} m-2" [class.text-linethrough]="userScope.length > 0 && userScope.indexOf('k')<0" (click)="toggleUserScope('k')" *ngIf="searchScope.indexOf('k')>=0">Companies</button>
				<button class="btn btn-sm btn-{{ userScope.indexOf('c') < 0 ? '' : 'outline-light'}} m-2" [class.text-linethrough]="userScope.length > 0 && userScope.indexOf('c')<0" (click)="toggleUserScope('c')" *ngIf="searchScope.indexOf('c')>=0">Contacts</button>
				<button class="btn btn-sm btn-{{ userScope.indexOf('o') < 0 ? '' : 'outline-light'}} m-2" [class.text-linethrough]="userScope.length > 0 && userScope.indexOf('o')<0" (click)="toggleUserScope('o')" *ngIf="searchScope.indexOf('o')>=0">Orders</button>
				<button class="btn btn-sm btn-{{ userScope.indexOf('p') < 0 ? '' : 'outline-light'}} m-2" [class.text-linethrough]="userScope.length > 0 && userScope.indexOf('p')<0" (click)="toggleUserScope('p')" *ngIf="searchScope.indexOf('p')>=0">Products</button>
				<button class="btn btn-sm btn-{{ userScope.indexOf('t') < 0 ? '' : 'outline-light'}} m-2" [class.text-linethrough]="userScope.length > 0 && userScope.indexOf('t')<0" (click)="toggleUserScope('t')" *ngIf="searchScope.indexOf('t')>=0">Tasks</button>
				<button class="btn btn-sm btn-{{ userScope.indexOf('u') < 0 ? '' : 'outline-light'}} m-2" [class.text-linethrough]="userScope.length > 0 && userScope.indexOf('u')<0" (click)="toggleUserScope('p')" *ngIf="searchScope.indexOf('u')>=0">Users</button>
			</div>
			<!--div style="max-height:355px;overflow-y:scroll"-->
			<ng-scrollbar visibility="hover" style="min-height:125px;max-height:450px;">
				
				<div *ngIf="records === null" class="search-intro">
					<div class="d-flex justify-content-center">
						<div *ngFor="let scope of searchScope.split('')" class="avatar-title h5 bg-secondary bg-soft rounded-circle">
							<i class="bx text-secondary" [ngClass]="{
								'bx-user': scope == 'c',
								'bx-buildings': scope == 'k',
								'bx-dollar': scope == 'o',
								'bx-shopping-bag': scope == 'p',
								'bx-check-square': scope == 't',
								'bx-key': scope == 'u',
							}"></i>
						</div>
					</div>
					<h6>{{ __name + '.Scope.' + searchScope | translate }}</h6>
				</div>

				<div *ngIf="form.loading == 'loaded' && records?.length === 0" class="search-intro text-danger">
					<div class="d-flex justify-content-center">
						<div class="avatar-title h5 rounded-circle bg-danger bg-soft text-dark">
							<i class="bx bx-x" style="font-size:24px;"></i>
						</div>
					</div>
					<h6>No results found, try again.</h6>
				</div>
				<mat-option *ngFor="let result of records" [value]="result" class="search-result two-lines-option mat-option-{{fieldSize}}" [ngClass]="{ 'icon-vertical-center' : result.class_name == 'Product' }">

					<ng-container *ngIf="result.class_name == 'Customer'">
						<div class="avatar-xs my-auto" *ngIf="showGraphic">
							<span class="avatar-title rounded-circle {{ result.genderBgClass() }}" avatar [cid]="result.id"
								[email]="result.metadata['email']" [size]="144" [avatar-class]="result.genderBgClass()">
								{{ (result.metadata['fname'] || ' ')[0] + (result.metadata['lname'] || ' ')[0] }}
							</span>
						</div>
						<div [ngClass]="{ 'ps-1': !showGraphic }">
							<h6><span [innerHTML]="result.highlights['heading'] || result.heading"></span>&nbsp; 
								<span class="badge bg-soft bg-primary text-primary">{{ result.metadata['suburb'] }}</span>
								<span *ngIf="result.metadata['membership_num']"><i class="bx bxs-star text-warning"></i> {{ '#' + result.metadata['membership_num'] }}</span>
								<span *ngIf="result.matches[0] == 'tokens'" class="badge bg-pink bg-soft align-top" ngbtooltip="Your search matches related information about this customer">related</span>
								<span *ngIf="debug('HINTS')" class="badge text-orange align-top">{{ result.score| number }}%</span>
							</h6>
							<p><span [innerHTML]="result.highlights['subheading'] || result.subheading"></span></p>
							<p class="text-secondary" *ngIf="advanced && authenticatedUser.expertise('intermediate') && result.filteredHighlights"><span *ngFor="let h of result.filteredHighlights | keyvalue" class="me-2"><strong>{{ __name + '.MatchedAttributes.' + h.key | translate }}:</strong>&nbsp;<span [innerHTML]="h.value"></span></span></p>
						</div>
					</ng-container>
					
					<ng-container *ngIf="result.class_name == 'Order'">
						<div class="avatar-xs my-auto" *ngIf="showGraphic">
							<span class="avatar-title bg-secondary bg-soft text-dark rounded-circle">{{ result.metadata['initials'] }}</span>
						</div>
						<div [ngClass]="{ 'ps-1': !showGraphic }">
							<h6>Order #<span [innerHTML]="result.highlights['subheading'] || result.subheading"></span>&nbsp; 
								<span class="badge bg-secondary text-dark bg-soft">{{ 'Models.Order.Values.status.' + result.metadata['status'] | translate }}</span> <i class="bx bxs-star text-warning" *ngIf="result.metadata['membership_id']"></i></h6>
								<span *ngIf="debug('HINTS')" class="badge text-orange align-top">{{ result.score| number }}%</span>
							<p>
								<span [innerHTML]="result.highlights['heading'] || result.heading"></span>, {{ result.metadata['total_value_inc'] | currency: selectedCompany.currency:'symbol-narrow':'1.2-2' }}
							</p>
						</div>
					</ng-container>

					<ng-container *ngIf="result.class_name == 'Product'">
						<div class="avatar-xs text-center bg-secondary bg-soft my-auto pt-0" *ngIf="showGraphic && result.metadata['hero_img']">
							<img [src]="result.metadata['hero_img']" />
						</div>
						<div class="avatar-xs text-center bg-secondary bg-soft my-auto" *ngIf="showGraphic && !result.metadata['hero_img']">
							<i class="text-dark mdi font-size-22 {{ result.getIcon() }}"></i>
						</div>
						<div [ngClass]="{ 'ps-1': !showGraphic }">
							<ng-container *ngIf="altSelection">
								<button *ngIf="altSelection.match('add-product-to-order')" (click)="onSelect(result, $event)" ngbTooltip="add to current order" class="show-on-hover btn btn-sm bg-dark float-end border-0 p-1 ps-3 pe-3 me-1">
									<i class="bx bx-plus text-white font-size-19"></i>
								</button>
							</ng-container>
							<h6><span [innerHTML]="result.highlights['heading'] || result.heading"></span>&nbsp;
								<span *ngIf="!altSelection" class="badge bg-secondary bg-soft align-top">{{ 'Models.Product.Values.variety.'+result.metadata['variety'] | translate }}</span>
								<span *ngIf="debug('HINTS')" class="badge text-orange align-top">{{ result.score| number }}%</span>
							</h6>
							<p>
								<span *ngIf="result.subheading" [innerHTML]="(result.highlights['subheading'] || result.subheading) + ', '"></span>
								<span *ngIf="result.metadata['units_available'] && asFloat(result.metadata['units_available']) != 0">{{ result.metadata['units_available'] }} units, </span>
								<span *ngIf="result.metadata['price']">{{ result.metadata['price'] | currency: selectedCompany.currency:'symbol-narrow':'1.2-2' }}</span>
								<span *ngIf="result.metadata['bundle_content_product_count']">, with {{ result.metadata['bundle_content_product_count'] }} units of {{ result.metadata['bundle_content_distinct_products'] }} products</span>
							</p>
							<p class="text-secondary d-block text-truncate" *ngIf="advanced && authenticatedUser.expertise('intermediate') && result.filteredHighlights"><span *ngFor="let h of result.filteredHighlights | keyvalue" class="me-2"><strong>{{ __name + '.MatchedAttributes.' + h.key | translate }}:</strong>&nbsp;<span [innerHTML]="h.value"></span><br/></span></p>
						</div>
					</ng-container>

					<ng-container *ngIf="result.class_name == 'Task'">
Task
					</ng-container>

					<ng-container *ngIf="result.class_name == 'User'">
User
					</ng-container>

					<ng-container *ngIf="result.class_name == 'Company'">
						<div class="avatar-xs my-auto" *ngIf="showGraphic && result.metadata['logo_img']">
							<img class="rounded-circle" [src]="result.metadata['logo_img']" />
						</div>
						<div class="avatar-xs text-center bg-secondary bg-soft my-auto" *ngIf="showGraphic && !result.metadata['logo_img']">
							<i class="text-dark bx bx-buildings font-size-22"></i>
						</div>
						<div [ngClass]="{ 'ps-1': !showGraphic }">
							<h6><span [innerHTML]="result.highlights['heading'] || result.heading"></span>&nbsp; 
								<span class="badge bg-soft bg-primary text-primary">{{ result.metadata['alpha2'] }}</span>
								<span *ngIf="result.matches[0] == 'tokens'" class="badge bg-pink bg-soft align-top" ngbtooltip="Your search matches related information about this customer">related</span>
								<span *ngIf="debug('HINTS')" class="badge text-orange align-top">{{ result.score| number }}%</span>
							</h6>
							<p><span [innerHTML]="result.highlights['subheading'] || result.subheading"></span></p>
							<p class="text-secondary" *ngIf="advanced && authenticatedUser.expertise('intermediate') && result.filteredHighlights"><span *ngFor="let h of result.filteredHighlights | keyvalue" class="me-2"><strong>{{  __name + '.MatchedAttributes.' + h.key | translate }}:</strong>&nbsp;<span [innerHTML]="h.value"></span></span></p>
						</div>
					</ng-container>

				</mat-option>
			<!--/div-->
			</ng-scrollbar>

			<div class="{{ bsCssClassPrefix }}-footer pt-2 pe-1">

				<p *ngIf="form.loading == 'loaded' && !records"> Start typing to search.. </p>
				<p *ngIf="form.loading == 'loaded' && records?.length == 0"> Start typing to search.. </p>
				<p *ngIf="form.loading == 'loaded' && records?.length > 0">Showing {{ records.length > pageSize ? pageSize : records.length }} of {{ totalRecords }} results</p>
				<p *ngIf="form.loading == 'loading'">Searching..</p>

				<div>
				<ng-container *ngIf="records?.length == 0">
					<button *ngIf="searchScope.length == 1" (click)="createRecord(searchInput.value, searchScope);" class="btn mt-1 text-white btn-sm bg-primary">Create</button>
					<div *ngIf="searchScope.length > 1" ngbDropdown class="d-inline-block me-2">
						<button class="mt-1 btn btn-sm btn-primary" ngbDropdownToggle><span>Create</span><i class="ms-2 bx bx-chevron-down"></i></button>
						<div ngbDropdownMenu>
							<button *ngFor="let scope of this.searchScope.split('')" ngbDropdownItem (click)="createRecord(searchInput.value, scope)" [ngClass]="{'d-none':['o'].includes(scope)}">
								<span>{{ __name + '.Create.' + scope | translate }}</span>
							</button>
						</div>
					</div>
				</ng-container>

				<ng-container *ngIf="allowScanner">
					<button type="button" (click)="toggleCamera()" class="mt-1 ms-1 btn btn-sm" [ngClass]="{ 'btn-success' : action.isStart, 'btn-primary' : !action.isStart, 'btn-secondary': action.isLoading }">
						<i *ngIf="!action.isLoading" class="bx bxs-camera align-middle me-2 font-size-14"></i>
						<i *ngIf="action.isLoading" class="bx bx-loader-alt bx-spin align-middle me-2 font-size-14"></i>
						<span *ngIf="action.isStart">Disable <strong>scanner</strong></span>
						<span *ngIf="!action.isStart">Enable <strong>scanner</strong></span>
					</button>
				</ng-container>
				</div>
			</div>
			<div class="{{ bsCssClassPrefix }}-footer border-0 mt-0 pb-0" [ngClass]="{ 'd-none': !action.isStart || !allowScanner }">
				<!-- For camera -->
				<ngx-scanner-qrcode [constraints]="{audio:true,video:false}" #action="scanner"></ngx-scanner-qrcode>
			</div>
			<mat-option class="d-none"><!-- without an option present, the panel doesn't show up (instructions and footer are not clickable options) --></mat-option>
		</mat-autocomplete>
		<mat-hint>{{ searchHint }}</mat-hint>
	</mat-form-field>
</form>